import { TFunction } from 'i18next';
import { z } from 'zod';
import { createPredicateSchema } from '@/entities/predicate';

export const createKnowledgeFormSchema = (t: TFunction<readonly ['knowledge', 'common']>) => {
  return z.object({
    name: z.string().min(1, t('common:required')),
    text: z.string().min(1, t('common:required')),
    predicate: createPredicateSchema(t('common:predicateHasIssues')).optional().nullable(),
  });
};

export type KnowledgeFormValues = z.infer<ReturnType<typeof createKnowledgeFormSchema>>;
